import * as React from "react";
import DeviceContext from "./../../../service/indentifyDevice";
export interface IFtUnderMaintenanceProps {
	payinMaintenance: string;
}

if (DeviceContext().isDesktop) {
	require("../../../../assets/scss/components/toc/fundTransfer/ftMaintenance/ftUnderMaintenanceDsk.scss");
} else if (DeviceContext().isMobile) {
	require("../../../../assets/scss/components/toc/fundTransfer/ftMaintenance/ftUnderMaintenanceMob.scss");
} else {
	require("../../../../assets/scss/components/toc/fundTransfer/ftMaintenance/ftUnderMaintenanceTab.scss");
}

const FtUnderMaintenance: React.FC<IFtUnderMaintenanceProps> = (props) => {
	return (
		<div className="ft_maintenance_wrap">
			<div className="cir_icon"></div>
			<p className="ment_mesg">We are currently processing requests</p>
			<h2 className="msg">Check again after {props.payinMaintenance} </h2>
		</div>
	);
};

export default FtUnderMaintenance;
